import React, { Component } from "react";

import "./blog.css";
import blogLogo from "../../../assets/blogLogo.png";
import blogSide from "../../../assets/Blogging-bro.svg";
import firebase from "firebase";
import WordLimit from "react-word-limit";
import Loader from "../../components/loader/loader";

export default class Blog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blogs: [],
      loading: true
    };
  }

  componentDidMount() {
    firebase
      .firestore()
      .collection("blog")
      .onSnapshot((snap) => {
        snap.docChanges().forEach((changes) => {
          var blog = changes.doc.data();
          blog.id = changes.doc.id;
          this.setState({
            blogs: [...this.state.blogs, blog],
          });
        });
        this.setState({
          loading: false
        })
      });
  }

  render() {
    return (
      <>
        {
          this.state.loading
            ?
            <Loader />
            :
            <div className="blogwholepage">
        <div className="blog-firstsec">
          <div className="blog-firstsec-container">
            <img src={blogLogo} alt="blogLogo" />
            <img src={blogSide} alt="blogSide" />
          </div>
        </div>
        <div className="blog-secondsec">
          {this.state.blogs.map((blog) => {
            return (
              <a className="blog-secondsec-item1" href={"/blog/" + blog.id}>
                <div className="imgconta">
                  <img src={blog.thumbnail} alt="mountain" />
                </div>
                <div className="blog-secondsec-item1-p-container">
                  <h3>{blog.title}</h3>
                  <p>
                    <WordLimit limit={550}>{blog.content}</WordLimit>
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
        }
        </>
    );
  }
}
